import { useEffect, useState } from 'react'
import { getReportAttendanceDropReportToAPI } from '../../../services/report/attendanceSum'

const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== '' && v !== null && v !== undefined
    )
  )

function UseReportAttendanceDropReportTo({
  orgId,
  search,
  groupId,
  dsId,
  dmId,
  teamId,
  language = 'en'
} = {}) {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let ignore = false
    const normalizedSearch = typeof search === 'string' ? search.trim() : search

    if (!orgId) {
      setOptions([])
      setRawData([])
      setLoading(false)
      return
    }

    const getData = async () => {
      setLoading(true)
      const headers = language ? { 'Accept-Language': language } : {}
      const resp = await getReportAttendanceDropReportToAPI(
        cleanParams({
          search: normalizedSearch,
          orgId,
          groupId,
          dsId,
          dmId,
          teamId
        }),
        headers
      )

      if (ignore) return

      setLoading(false)
      if (!resp) return
      if (resp.status) {
        setRawData(resp.result)
        const newData = resp.result.map((d, index) => ({
          value: d?.username,
          label: d?.reportTo,
          key: index
        }))
        setOptions(newData)
      } else {
        setOptions([])
        setRawData([])
      }
    }

    getData()

    return () => {
      ignore = true
    }
  }, [orgId, search, groupId, dsId, dmId, teamId, language])

  return { options, rawData, loading }
}

export default UseReportAttendanceDropReportTo
